import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/DashboardLayout';
import F606AdminHub from '../../components/f606-admin/F606AdminHub';
import { useLanguage } from '../../context/LanguageContext';

export default function F606ActionsPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <DashboardLayout
      title="مركز العمليات"
      titleEn="Operations Center"
      subtitle="إجراءات مباشرة على تطبيق 606 FITNESS — طلبات، مستخدمون، اشتراكات، بثّ إعلانات"
      subtitleEn="Live actions on the 606 FITNESS app — orders, users, subscriptions, broadcast"
      screenCode="F606-OPS"
      backPath="/control/f606"
      onBack={() => navigate('/control/f606')}
      breadcrumb={[
        { labelAr: '606 فتنس', labelEn: '606 FITNESS', path: '/control/f606' },
        { labelAr: 'مركز العمليات', labelEn: 'Operations Center' },
      ]}
    >
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <F606AdminHub language={language} />
      </section>
    </DashboardLayout>
  );
}
